import { createContext, useContext, useState, useEffect } from "react";

const LanguageContext = createContext(null);

export const translations = {
  es: {
    // Navigation
    nav_producto: "Producto",
    nav_beneficios: "Beneficios",
    nav_faq: "FAQ",
    nav_login: "Iniciar Sesión",
    nav_cuenta: "Mi Cuenta",
    nav_comprar: "Comprar Ahora",
    
    // Hero
    hero_subtitle: "La leyenda Mexicana",
    hero_description: "Catnip cultivado artesanalmente en Guanajuato. Hecho por gente local con dedicación para darle la mejor calidad a tu gatito.",
    hero_btn_comprar: "¡Quiero Mi Caja! - $500 MXN",
    hero_btn_conocer: "Conocer Más",
    hero_envio: "MESES SIN INTERESES",
    hero_envio_mexico: "ENVÍOS A TODO MÉXICO",
    hero_pago: "Pago seguro",
    
    // What is Catnip Section
    catnip_section_title: "¿QUÉ ES EL CATNIP?",
    catnip_card1_title: "ES UNA PLANTA DESHIDRATADA",
    catnip_card1_desc: "La NEPETA CATARIA es una variedad de la menta y deshidratada concentra más sus beneficios.",
    catnip_card2_title: "EL PREMIO FAVORITO DE LOS GATOS",
    catnip_card2_desc: "El catnip es el premio por excelencia de los gatos. Siempre estará encantado de probarlo, olerlo y hasta bañarse en él.",
    catnip_card3_title: "NO CONTIENE ADITIVOS",
    catnip_card3_desc: "El catnip no contiene ningún tipo de aditivo ya que no los requiere. Al ser una planta deshidratada se conserva de forma natural.",
    catnip_card4_title: "NO ES ADICTIVO NI DAÑINO",
    catnip_card4_desc: "El catnip solo tiene efectos positivos sobre los gatos. Solo en casos de que sea un gato muy agresivo o tenga alguna condición fuera de lo normal se recomendaría la opinión de su médico veterinario.",
    
    // Product Section
    product_section_title: "CAJA",
    product_section_brand: "GATOFELIZ",
    product_section_description: "LA CAJA GATOFELIZ consiste en un paquete de 35 bolsitas de 1oz de catnip. Este paquete está pensado para VETERINARIAS y TIENDAS DE MASCOTAS que quieren vender catnip Mexicano y/o que quieren premiar a sus clientes favoritos con una bolsita como regalo.",
    product_title: "Pack GATOFELIZ",
    product_description: "El Pack GATOFELIZ consiste en un paquete de 35 bolsitas de 1oz de catnip. Este paquete está pensado para VETERINARIAS y TIENDAS DE MASCOTAS que quieren vender catnip Mexicano y/o que quieren premiar a sus clientes favoritos con una bolsita como regalo.",
    product_price: "$500 MXN",
    product_subtitle: "Caja con 35 bolsitas de 1oz de catnip mexicano",
    product_btn: "Comprar Caja",
    product_pago: "Pago seguro con tarjeta",
    
    // Benefits Section
    benefits_title: "¿Por qué es saludable darle catnip a mi gato?",
    benefits_subtitle: "Los beneficios del CATNIP en los gatitos son muchos y van desde físicos hasta emocional, te contamos 4 de ellos.",
    benefit_1_title: "Rompe la Rutina",
    benefit_1_desc: "Rompe su rutina y dale 1 o 2 veces por semana para gozar de sus beneficios y no perder efectividad. Esto lo estimulara física y mentalmente.",
    benefit_2_title: "Reducción de Estrés",
    benefit_2_desc: "Después de una fase de excitación, muchos gatos entran en un estado de relajación. Esto puede ayudar en momentos de ansiedad o cambios de entorno.",
    benefit_3_title: "Mejora la Socialización",
    benefit_3_desc: "En hogares con varios gatos, puede fomentar interacciones positivas y juego entre ellos.",
    benefit_4_title: "Evita Sedentarismo",
    benefit_4_desc: "La estimulación física le ayuda a incrementar su actividad y mejora su estado de salud.",
    
    // FAQ Section
    faq_title: "Preguntas Frecuentes",
    faq_subtitle: "TODO LO QUE NECESITAS SABER SOBRE EL CATNIP",
    faq_1_q: "¿Qué pasa si le doy catnip todos los días?",
    faq_1_a: "NO LE PASA NADA ya que el CATNIP es completamente seguro e inofensivo. Sin embargo, lo RECOMENDABLE es darle 1 o 2 veces por SEMANA para gozar de sus beneficios y no pierda efectividad.",
    faq_2_q: "¿El catnip es seguro para todos los gatos?",
    faq_2_a: "✅ Ideal para: Gatos adultos que viven en interiores, gatos tímidos que necesitan estimulación, felinos con sobrepeso o aburridos. 🚫 No recomendable: Gatas embarazadas (consulta con tu veterinario), gatos con problemas cardíacos (consulta con tu veterinario), gatos con historial de agresividad (consulta con tu veterinario).",
    faq_3_q: "¿Cómo uso el catnip?",
    faq_3_a: "Frota una cucharada de catnip entre tus dedos para liberar el aroma. Espolvoréalo en una superficie lisa o donde quieras que tu gato juegue. Mantén cerrado el empaque y en un lugar fresco para que no pierda propiedades.",
    faq_4_q: "¿Funciona en todos los gatos?",
    faq_4_a: "Aproximadamente el 70% de los gatos reaccionan al catnip. La sensibilidad es hereditaria. Los gatitos menores de 3 meses generalmente no responden. Si tu gato no reacciona, ¡no te preocupes! Aún puede disfrutar del sabor y textura.",
    faq_5_q: "¿Hacen envíos a todo México?",
    faq_5_a: "¡Sí! El envío está incluido y lo hacemos a tu domicilio. Te lo enviamos a donde nos indiques, en caso de ser complicado por horario o por alguna otra razón, lo podemos enviar a la sucursal de paquetería que tengas más cercana. Compartiremos la guía en cuanto se realice el envío para que puedas darle seguimiento.",
    
    // Blog Section
    blog_title: "Blogs Gatunos",
    blog_subtitle: "Recursos sobre salud y bienestar felino",
    blog_1_title: "Bienestar Felino",
    blog_1_desc: "Blog especializado en el bienestar y cuidado integral de los gatos.",
    blog_2_title: "Feel Cats",
    blog_2_desc: "Consejos, tips y artículos sobre comportamiento y salud felina.",
    blog_3_title: "La Casita de los Animales",
    blog_3_desc: "Blog con información útil sobre el cuidado y alimentación de gatos.",
    blog_4_title: "Todo sobre Gatos - Cats.com",
    blog_4_desc: "El portal más completo sobre gatos: razas, cuidados, alimentación y salud felina.",
    blog_visitar: "Visitar blog →",
    
    // CTA Section
    cta_title: "¿Listo para hacer feliz a tu gato?",
    cta_description: "Únete a miles de dueños de gatos y veterinarios que confían en GATOFELIZ. Tu gatito te lo agradecerá con ronroneos.",
    cta_btn: "¡SÍ! QUIERO MI CAJA",
    
    // Footer
    footer_contacto: "Contacto",
    footer_hecho: "Hecho en México",
    footer_derechos: "© 2025 GATOFELIZ. Todos los derechos reservados. Hecho con 🐱 en México.",
    
    // Stock
    sold_out: "Agotado",
    sold_out_contact: "Contáctanos",
    quantity: "Cantidad",
    stock_available: "disponibles",
    
    // Payment Modal
    payment_modal_title: "Selecciona tu método de pago",
    payment_card: "Tarjeta de Crédito/Débito",
    cancel: "Cancelar",
    
    // Auth Modal
    auth_login_title: "Iniciar Sesión",
    auth_register_title: "Crear Cuenta",
    auth_forgot_title: "Recuperar Contraseña",
    auth_login_subtitle: "Accede a tu cuenta para ver tu historial",
    auth_register_subtitle: "Crea una cuenta para guardar tus datos",
    auth_forgot_subtitle: "Te enviaremos un enlace para restablecer tu contraseña",
    auth_google_btn: "Continuar con Google",
    auth_or: "o",
    auth_name_placeholder: "Nombre (opcional)",
    auth_email_placeholder: "Correo electrónico",
    auth_password_placeholder: "Contraseña",
    auth_phone_placeholder: "Teléfono (opcional)",
    auth_login_btn: "Iniciar Sesión",
    auth_register_btn: "Crear Cuenta",
    auth_reset_btn: "Enviar Enlace",
    auth_loading: "Cargando...",
    auth_no_account: "¿No tienes cuenta?",
    auth_create_account: "Crear cuenta",
    auth_have_account: "¿Ya tienes cuenta?",
    auth_login_link: "Iniciar sesión",
    auth_forgot_password: "¿Olvidaste tu contraseña?",
    auth_back_to_login: "Volver a Iniciar Sesión",
    auth_error_invalid_email: "Por favor ingresa un email válido",
    auth_error_password_short: "La contraseña debe tener al menos 6 caracteres",
    
    // Language Modal
    lang_title: "Selecciona tu idioma",
    lang_subtitle: "Select your language / Choisissez votre langue",
  },
  
  en: {
    // Navigation
    nav_producto: "Product",
    nav_beneficios: "Benefits",
    nav_faq: "FAQ",
    nav_login: "Sign In",
    nav_cuenta: "My Account",
    nav_comprar: "Buy Now",
    
    // Hero
    hero_subtitle: "The Mexican Legend",
    hero_description: "Artisanally grown catnip from Guanajuato. Made by local people with dedication to give your kitty the best quality.",
    hero_btn_comprar: "I Want My Box! - $500 MXN",
    hero_btn_conocer: "Learn More",
    hero_envio: "INTEREST-FREE PAYMENTS",
    hero_envio_mexico: "SHIPPING TO ALL MEXICO",
    hero_pago: "Secure payment",
    
    // What is Catnip Section
    catnip_section_title: "WHAT IS CATNIP?",
    catnip_card1_title: "IT'S A DEHYDRATED PLANT",
    catnip_card1_desc: "It's a variety of mint that is traditionally and naturally dehydrated.",
    catnip_card2_title: "CATS' FAVORITE TREAT",
    catnip_card2_desc: "It's the treat that cats will always love to smell, taste, and even bathe in.",
    catnip_card3_title: "NO CHEMICAL ADDITIVES",
    catnip_card3_desc: "Catnip doesn't need chemicals or preservatives since being dehydrated it preserves naturally.",
    catnip_card4_title: "NOT ADDICTIVE OR HARMFUL",
    catnip_card4_desc: "Catnip only has positive effects on cats. Only in cases of very aggressive cats or those with unusual conditions would a veterinarian's opinion be recommended.",
    
    // Product Section
    product_section_title: "BOX",
    product_section_brand: "GATOFELIZ",
    product_section_description: "The GATOFELIZ BOX consists of a package of 35 bags of 1oz catnip. This package is designed for VETERINARY CLINICS and PET STORES that want to sell Mexican catnip and/or reward their favorite customers with a bag as a gift.",
    product_title: "GATOFELIZ Pack",
    product_description: "The GATOFELIZ Pack consists of a package of 35 bags of 1oz catnip. This package is designed for veterinary clinics and pet stores that want to sell Mexican catnip and/or reward their favorite customers with a bag as a gift.",
    product_price: "$500 MXN",
    product_subtitle: "Box with 35 bags of 1oz Mexican catnip",
    product_btn: "Buy Box",
    product_pago: "Secure card payment",
    
    // Benefits Section
    benefits_title: "Why is it healthy to give catnip to my cat?",
    benefits_subtitle: "The benefits of catnip for cats are many, ranging from physical to emotional.",
    benefit_1_title: "Break the Routine",
    benefit_1_desc: "Catnip encourages play, helping to prevent sedentary lifestyle and feline obesity. Physical and mental stimulation.",
    benefit_2_title: "Stress Reduction",
    benefit_2_desc: "After an excitation phase, many cats enter a state of relaxation. This can help during moments of anxiety or environmental changes.",
    benefit_3_title: "Improves Socialization",
    benefit_3_desc: "In homes with multiple cats, it can foster positive interactions and play between them.",
    benefit_4_title: "Promotes Use of Scratchers",
    benefit_4_desc: "Applying catnip to scratchers or toys can attract cats to them, helping to prevent furniture scratching.",
    
    // FAQ Section
    faq_title: "Frequently Asked Questions",
    faq_subtitle: "Everything you need to know about GATOFELIZ",
    faq_1_q: "What happens if I give catnip every day?",
    faq_1_a: "NOTHING BAD HAPPENS since CATNIP is completely safe and harmless. However, it's RECOMMENDED to give it 1 or 2 times per WEEK to enjoy its benefits and maintain effectiveness.",
    faq_2_q: "Is catnip safe for all cats?",
    faq_2_a: "✅ Ideal for: Indoor adult cats, shy cats needing stimulation, overweight or bored felines. 🚫 Not recommended: Pregnant cats (consult your vet), cats with heart problems (consult your vet), cats with history of aggression (consult your vet).",
    faq_3_q: "How do I use catnip?",
    faq_3_a: "You can sprinkle a small amount on your cat's toys, bed or scratcher. You can also fill interactive toys. One teaspoon is enough for a play session. Store the rest in a cool, dry place.",
    faq_4_q: "Does it work on all cats?",
    faq_4_a: "Approximately 70% of cats react to catnip. Sensitivity is hereditary. Kittens under 3 months generally don't respond. If your cat doesn't react, don't worry! They can still enjoy the taste and texture.",
    faq_5_q: "Do you ship to all of Mexico?",
    faq_5_a: "Yes! Shipping is included and we deliver to your home. We'll send it wherever you indicate. If it's complicated due to schedule or any other reason, we can send it to the nearest shipping office. We'll share the tracking number as soon as the shipment is made.",
    
    // Blog Section
    blog_title: "Cat Blogs",
    blog_subtitle: "Resources about feline health and wellness",
    blog_1_title: "Feline Wellness",
    blog_1_desc: "Blog specialized in the wellness and comprehensive care of cats.",
    blog_2_title: "Feel Cats",
    blog_2_desc: "Tips, advice and articles about feline behavior and health.",
    blog_3_title: "La Casita de los Animales",
    blog_3_desc: "Blog with useful information about cat care and feeding.",
    blog_4_title: "All About Cats - Cats.com",
    blog_4_desc: "The most complete cat portal: breeds, care, nutrition and feline health.",
    blog_visitar: "Visit blog →",
    
    // CTA Section
    cta_title: "Ready to make your cat happy?",
    cta_description: "Join thousands of cat owners and veterinarians who trust GATOFELIZ. Your kitty will thank you with purrs.",
    cta_btn: "YES! I WANT MY BOX",
    
    // Footer
    footer_contacto: "Contact",
    footer_hecho: "Made in Mexico",
    footer_derechos: "© 2025 GATOFELIZ. All rights reserved. Made with 🐱 in Mexico.",
    
    // Stock
    sold_out: "Sold Out",
    sold_out_contact: "Contact Us",
    quantity: "Quantity",
    stock_available: "available",
    
    // Payment Modal
    payment_modal_title: "Select your payment method",
    payment_card: "Credit/Debit Card",
    cancel: "Cancel",
    
    // Auth Modal
    auth_login_title: "Sign In",
    auth_register_title: "Create Account",
    auth_forgot_title: "Reset Password",
    auth_login_subtitle: "Access your account to view your history",
    auth_register_subtitle: "Create an account to save your data",
    auth_forgot_subtitle: "We will send you a link to reset your password",
    auth_google_btn: "Continue with Google",
    auth_or: "or",
    auth_name_placeholder: "Name (optional)",
    auth_email_placeholder: "Email address",
    auth_password_placeholder: "Password",
    auth_phone_placeholder: "Phone (optional)",
    auth_login_btn: "Sign In",
    auth_register_btn: "Create Account",
    auth_reset_btn: "Send Link",
    auth_loading: "Loading...",
    auth_no_account: "Don't have an account?",
    auth_create_account: "Create account",
    auth_have_account: "Already have an account?",
    auth_login_link: "Sign in",
    auth_forgot_password: "Forgot your password?",
    auth_back_to_login: "Back to Sign In",
    auth_error_invalid_email: "Please enter a valid email",
    auth_error_password_short: "Password must be at least 6 characters",
    
    // Language Modal
    lang_title: "Select your language",
    lang_subtitle: "Selecciona tu idioma / Choisissez votre langue",
  },
  
  fr: {
    // Navigation
    nav_producto: "Produit",
    nav_beneficios: "Avantages",
    nav_faq: "FAQ",
    nav_login: "Connexion",
    nav_cuenta: "Mon Compte",
    nav_comprar: "Acheter",
    
    // Hero
    hero_subtitle: "La Légende Mexicaine",
    hero_description: "Herbe à chat cultivée artisanalement à Guanajuato. Faite par des gens locaux avec dévouement pour offrir la meilleure qualité à votre chat.",
    hero_btn_comprar: "Je Veux Ma Boîte! - $500 MXN",
    hero_btn_conocer: "En Savoir Plus",
    hero_envio: "PAIEMENT SANS INTÉRÊTS",
    hero_envio_mexico: "LIVRAISON DANS TOUT LE MEXIQUE",
    hero_pago: "Paiement sécurisé",
    
    // What is Catnip Section
    catnip_section_title: "QU'EST-CE QUE L'HERBE À CHAT?",
    catnip_card1_title: "C'EST UNE PLANTE DÉSHYDRATÉE",
    catnip_card1_desc: "C'est une variété de menthe qui est traditionnellement et naturellement déshydratée.",
    catnip_card2_title: "LA FRIANDISE PRÉFÉRÉE DES CHATS",
    catnip_card2_desc: "C'est la friandise que les chats aimeront toujours sentir, goûter et même s'y baigner.",
    catnip_card3_title: "SANS ADDITIFS CHIMIQUES",
    catnip_card3_desc: "L'herbe à chat n'a pas besoin de produits chimiques ni de conservateurs car étant déshydratée, elle se conserve naturellement.",
    catnip_card4_title: "NI ADDICTIF NI NOCIF",
    catnip_card4_desc: "L'herbe à chat n'a que des effets positifs sur les chats. Seulement en cas de chats très agressifs ou avec des conditions inhabituelles, l'avis d'un vétérinaire serait recommandé.",
    
    // Product Section
    product_section_title: "BOÎTE",
    product_section_brand: "GATOFELIZ",
    product_section_description: "La BOÎTE GATOFELIZ se compose d'un paquet de 35 sachets de 1oz d'herbe à chat. Ce paquet est conçu pour les CLINIQUES VÉTÉRINAIRES et les ANIMALERIES qui veulent vendre de l'herbe à chat mexicaine et/ou récompenser leurs clients préférés avec un sachet en cadeau.",
    product_title: "Pack GATOFELIZ",
    product_description: "Le Pack GATOFELIZ se compose d'un paquet de 35 sachets de 1oz d'herbe à chat. Ce paquet est conçu pour les cliniques vétérinaires et les animaleries qui veulent vendre de l'herbe à chat mexicaine et/ou récompenser leurs clients préférés avec un sachet en cadeau.",
    product_price: "$500 MXN",
    product_subtitle: "Boîte avec 35 sachets de 1oz d'herbe à chat mexicaine",
    product_btn: "Acheter la Boîte",
    product_pago: "Paiement sécurisé par carte",
    
    // Benefits Section
    benefits_title: "Pourquoi est-il sain de donner de l'herbe à chat à mon chat?",
    benefits_subtitle: "Les bienfaits de l'herbe à chat pour les chats sont nombreux, allant du physique à l'émotionnel.",
    benefit_1_title: "Casser la Routine",
    benefit_1_desc: "L'herbe à chat encourage le jeu, aidant à prévenir la sédentarité et l'obésité féline. Stimulation physique et mentale.",
    benefit_2_title: "Réduction du Stress",
    benefit_2_desc: "Après une phase d'excitation, de nombreux chats entrent dans un état de relaxation. Cela peut aider lors de moments d'anxiété ou de changements d'environnement.",
    benefit_3_title: "Améliore la Socialisation",
    benefit_3_desc: "Dans les foyers avec plusieurs chats, cela peut favoriser les interactions positives et le jeu entre eux.",
    benefit_4_title: "Favorise l'Utilisation des Griffoirs",
    benefit_4_desc: "Appliquer de l'herbe à chat sur les griffoirs ou les jouets peut attirer les chats vers eux, aidant à éviter qu'ils griffent les meubles.",
    
    // FAQ Section
    faq_title: "Questions Fréquentes",
    faq_subtitle: "Tout ce que vous devez savoir sur GATOFELIZ",
    faq_1_q: "Que se passe-t-il si je donne de l'herbe à chat tous les jours?",
    faq_1_a: "RIEN DE MAL NE SE PASSE car l'HERBE À CHAT est complètement sûre et inoffensive. Cependant, il est RECOMMANDÉ de la donner 1 ou 2 fois par SEMAINE pour profiter de ses bienfaits et maintenir son efficacité.",
    faq_2_q: "L'herbe à chat est-elle sûre pour tous les chats?",
    faq_2_a: "✅ Idéal pour: Chats adultes d'intérieur, chats timides ayant besoin de stimulation, félins en surpoids ou ennuyés. 🚫 Non recommandé: Chattes enceintes (consultez votre vétérinaire), chats avec des problèmes cardiaques (consultez votre vétérinaire), chats avec un historique d'agressivité (consultez votre vétérinaire).",
    faq_3_q: "Comment utiliser l'herbe à chat?",
    faq_3_a: "Vous pouvez saupoudrer une petite quantité sur les jouets de votre chat, son lit ou son griffoir. Vous pouvez également remplir des jouets interactifs. Une cuillère à café suffit pour une session de jeu. Conservez le reste dans un endroit frais et sec.",
    faq_4_q: "Ça fonctionne sur tous les chats?",
    faq_4_a: "Environ 70% des chats réagissent à l'herbe à chat. La sensibilité est héréditaire. Les chatons de moins de 3 mois ne répondent généralement pas. Si votre chat ne réagit pas, ne vous inquiétez pas! Il peut toujours apprécier le goût et la texture.",
    faq_5_q: "Livrez-vous dans tout le Mexique?",
    faq_5_a: "Oui! La livraison est incluse et nous livrons à votre domicile. Nous l'enverrons où vous l'indiquerez. Si c'est compliqué en raison de l'horaire ou de toute autre raison, nous pouvons l'envoyer au bureau d'expédition le plus proche. Nous partagerons le numéro de suivi dès que l'envoi sera effectué.",
    
    // Blog Section
    blog_title: "Blogs Félins",
    blog_subtitle: "Ressources sur la santé et le bien-être félin",
    blog_1_title: "Bien-être Félin",
    blog_1_desc: "Blog spécialisé dans le bien-être et les soins complets des chats.",
    blog_2_title: "Feel Cats",
    blog_2_desc: "Conseils, astuces et articles sur le comportement et la santé féline.",
    blog_3_title: "La Casita de los Animales",
    blog_3_desc: "Blog avec des informations utiles sur les soins et l'alimentation des chats.",
    blog_4_title: "Tout sur les Chats - Cats.com",
    blog_4_desc: "Le portail le plus complet sur les chats: races, soins, nutrition et santé féline.",
    blog_visitar: "Visiter le blog →",
    
    // CTA Section
    cta_title: "Prêt à rendre votre chat heureux?",
    cta_description: "Rejoignez des milliers de propriétaires de chats et de vétérinaires qui font confiance à GATOFELIZ. Votre chat vous remerciera avec des ronronnements.",
    cta_btn: "OUI! JE VEUX MA BOÎTE",
    
    // Footer
    footer_contacto: "Contact",
    footer_hecho: "Fabriqué au Mexique",
    footer_derechos: "© 2025 GATOFELIZ. Tous droits réservés. Fait avec 🐱 au Mexique.",
    
    // Stock
    sold_out: "Épuisé",
    sold_out_contact: "Contactez-nous",
    quantity: "Quantité",
    stock_available: "disponibles",
    
    // Payment Modal
    payment_modal_title: "Sélectionnez votre mode de paiement",
    payment_card: "Carte de Crédit/Débit",
    cancel: "Annuler",
    
    // Auth Modal
    auth_login_title: "Connexion",
    auth_register_title: "Créer un Compte",
    auth_forgot_title: "Réinitialiser le Mot de Passe",
    auth_login_subtitle: "Accédez à votre compte pour voir votre historique",
    auth_register_subtitle: "Créez un compte pour sauvegarder vos données",
    auth_forgot_subtitle: "Nous vous enverrons un lien pour réinitialiser votre mot de passe",
    auth_google_btn: "Continuer avec Google",
    auth_or: "ou",
    auth_name_placeholder: "Nom (optionnel)",
    auth_email_placeholder: "Adresse e-mail",
    auth_password_placeholder: "Mot de passe",
    auth_phone_placeholder: "Téléphone (optionnel)",
    auth_login_btn: "Se Connecter",
    auth_register_btn: "Créer un Compte",
    auth_reset_btn: "Envoyer le Lien",
    auth_loading: "Chargement...",
    auth_no_account: "Vous n'avez pas de compte?",
    auth_create_account: "Créer un compte",
    auth_have_account: "Vous avez déjà un compte?",
    auth_login_link: "Se connecter",
    auth_forgot_password: "Mot de passe oublié?",
    auth_back_to_login: "Retour à la Connexion",
    auth_error_invalid_email: "Veuillez entrer un e-mail valide",
    auth_error_password_short: "Le mot de passe doit comporter au moins 6 caractères",
    
    // Language Modal
    lang_title: "Choisissez votre langue",
    lang_subtitle: "Selecciona tu idioma / Select your language",
  }
};

export function LanguageProvider({ children }) {
  const [language, setLanguage] = useState("es");
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const savedLang = localStorage.getItem("gatofeliz_lang");
    if (savedLang && translations[savedLang]) {
      setLanguage(savedLang);
    } else {
      // Default to Spanish without showing modal
      setLanguage("es");
      localStorage.setItem("gatofeliz_lang", "es");
    }
  }, []);

  const selectLanguage = (lang) => {
    setLanguage(lang);
    localStorage.setItem("gatofeliz_lang", lang);
    setShowModal(false);
  };

  const t = (key) => {
    if (!language) return translations.es[key] || key;
    return translations[language][key] || translations.es[key] || key;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage: selectLanguage, t, showModal, setShowModal }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
